import { render, staticRenderFns } from "./page-content-type-page.vue?vue&type=template&id=a7c918f6&scoped=true"
import script from "./page-content-type-page.vue?vue&type=script&lang=js"
export * from "./page-content-type-page.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-page.vue?vue&type=style&index=0&id=a7c918f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c918f6",
  null
  
)

export default component.exports